(() => {
  'use strict';
  const init = (scope) => {
    scope.querySelectorAll('[data-sentyr-guide]').forEach((guide) => {
      if (guide.dataset.ready) return;
      guide.dataset.ready = 'true';
      const filter = guide.querySelector('[data-scent-filter]');
      const cards = [...guide.querySelectorAll('[data-scent-card]')];
      const update = () => {
        let count = 0;
        cards.forEach((card) => {
          const show = filter.value === 'all' || card.dataset.families.split(/\s+/).includes(filter.value);
          card.hidden = !show;
          if (show) count += 1;
        });
        guide.querySelector('[data-scent-count]').textContent = `${count} signature${count > 1 ? 's' : ''}`;
        guide.querySelector('[data-scent-empty]').hidden = count !== 0;
      };
      filter.addEventListener('change', update);
      update();
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
